import { Component, inject } from "@angular/core";
import { ButtonComponent } from "@husbanken/designsystem-angular-core";
import { Router } from "@angular/router";

@Component({
  selector: "bko-kartlegging-avslutt",
  imports: [ButtonComponent],
  templateUrl: "./kartlegging-avslutt.html",
  styleUrl: "./kartlegging-avslutt.scss",
})
export class KartleggingAvslutt {
  private router: Router = inject(Router);

  public tilBoligkompasset(): void {
    this.router.navigate([""]);
  }
}
